module.exports = __webpack_public_path__ + "img/CZ63078333.a4575636.png";